<template>
  <div class="py-3">
    <page-title title="Users" />
    <hr />
    <filtered-table :settings="tableSettings" @rowClicked="onRowClicked">
    </filtered-table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ApplicationUserList",
  props: {},
  data() {
    let base = this;
    return {
      tableSettings: {
        endpoint: '/api/applicationUser',
        columns: [
          {
            key: 'Id',
            name: 'ID',
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'email',
            name: 'Email Address',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'userName',
            name: 'User Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'firstName',
            name: 'First Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'lastName',
            name: 'Last Name',
            visible: true,
            sortable: true,
            filter: 'text'
          }
        ],
        getDefaultFilter: function () {
          return '';
        }
      }
    }
  },
  methods: {
    onRowClicked: function (item, context) {
      this.$router.push('/applicationUser/' + item.id);
    }
  },
  mounted () {
  }
};
</script>